import {
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
} from 'date-fns';
import type { CalendarView } from '@/types';

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export function calculateDateRange(
  calendarView: CalendarView,
  selectedDate: Date
): DateRange {
  const safeDate =
    selectedDate instanceof Date && !isNaN(selectedDate.getTime())
      ? new Date(selectedDate.getTime())
      : new Date();

  switch (calendarView) {
    case 'day':
      return {
        startDate: startOfDay(new Date(safeDate.getTime())),
        endDate: endOfDay(new Date(safeDate.getTime())),
      };
    case 'week':
      return {
        startDate: startOfWeek(new Date(safeDate.getTime()), { weekStartsOn: 1 }),
        endDate: endOfWeek(new Date(safeDate.getTime()), { weekStartsOn: 1 }),
      };
    case 'month':
      return {
        startDate: startOfMonth(new Date(safeDate.getTime())),
        endDate: endOfMonth(new Date(safeDate.getTime())),
      };
    case 'quarter':
      return {
        startDate: startOfQuarter(new Date(safeDate.getTime())),
        endDate: endOfQuarter(new Date(safeDate.getTime())),
      };
    case 'year':
      return {
        startDate: startOfYear(new Date(safeDate.getTime())),
        endDate: endOfYear(new Date(safeDate.getTime())),
      };
    default: {
      const _exhaustiveCheck: never = calendarView;
      return {
        startDate: startOfWeek(new Date(safeDate.getTime()), { weekStartsOn: 1 }),
        endDate: endOfWeek(new Date(safeDate.getTime()), { weekStartsOn: 1 }),
      };
    }
  }
}

export function isBookingInRange(
  bookingStartTime: string,
  bookingEndTime: string,
  rangeStart: Date,
  rangeEnd: Date
): boolean {
  const bookingStart = new Date(bookingStartTime);
  const bookingEnd = new Date(bookingEndTime);

  if (isNaN(bookingStart.getTime()) || isNaN(bookingEnd.getTime())) {
    return false;
  }

  return bookingStart <= rangeEnd && bookingEnd >= rangeStart;
}
